import React, { Component, Fragment } from "react";
import { Card, CardContent, FormControlLabel, Checkbox, Button, TextField } from "@material-ui/core";
import Swal from "sweetalert2";
import moment from "moment";
import adminService from "../../../Services/adminService";
import btaxLogo from "../../../assets/images/btaxLogo.png";
import bquickLogo from "../../../assets/images/bquick-logo.png";
import { USER_ROLES, PENDING_USER_ACTION_TYPES, PENDING_USER_TYPES } from "../../../global/userConstants";
class AdminPendingUsersManager extends Component {
  state = { pendingUsers: [], isExistingSelected: [], existingData: [], existingCardNum: "" };

  componentDidMount() {
    const roleType = localStorage.getItem("role");
    const permittedRoles = [USER_ROLES.admin, USER_ROLES.salesManager];
    if (!permittedRoles.includes(roleType)) this.props.history.push("/admin/users-manager");
    adminService.getPendingUsers().then((res) => {
      if (res["success"]) {
        const pendingUsers = res["pendingUsers"];

        if (!pendingUsers[0]) return;

        const isExistingSelected = new Array(pendingUsers.length);
        const existingData = [];

        for (let cur of isExistingSelected) {
          existingData.push({
            contact: true,
            email: true,
            num: true,
            officeName: true
          });
        }

        this.setState({
          pendingUsers,
          isExistingSelected,
          existingData
        });
      }
    });
  }

  render() {
    return (
      <div className="center">
        <Card>
          <CardContent>
            <h3 className="yellow-color">ממתינים לאישור</h3>
            <div className="mt-30">
              {this.state.pendingUsers.map((currentUser, index) => {
                const pendingReqTable = this.getCurrentPendingTable(currentUser);

                return (
                  <div key={currentUser.email} className="pending-user-wrapper">
                    <div className="inline-block" style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                      <div className="width50-per inline-block">
                        <h5 className="primary-color">פרטי המשתמש</h5>
                        {pendingReqTable}
                      </div>
                      <div className="inline-block relative">
                        <div>
                          {this.state.isExistingSelected[index] ? (
                            <div className="pending-back-wrapper">
                              <i
                                onClick={() => {
                                  this.triggerActionSelected(PENDING_USER_ACTION_TYPES.back, index);
                                }}
                                className="material-icons pointer width40"
                              >
                                replay
                              </i>
                            </div>
                          ) : null}

                          {currentUser.pendingType === PENDING_USER_TYPES.expiredBquickSub ||
                          currentUser.pendingType === PENDING_USER_TYPES.expiredBtaxSub ? (
                            <div>
                              <div className="is-info-wrapper success-color">---- Expired {currentUser.pendingType} Subscription ----</div>
                              <Button
                                onClick={(e) => {
                                  this.redirectToSpecificUser(currentUser.existingUserId, e);
                                }}
                                onMouseDown={(e) => {
                                  if (e.button === 1) {
                                    e.preventDefault();
                                    this.redirectToSpecificUser(currentUser.existingUserId, e);
                                  }
                                }}
                                color="primary"
                                variant="contained"
                              >
                                כניסה לכרטיס לקוח
                              </Button>
                              <div className="inline-block">
                                <Button
                                  disabled={this.state.isExistingSelected[index]}
                                  className="mr-20"
                                  color="primary"
                                  variant="contained"
                                  onClick={() => {
                                    this.triggerActionSelected(PENDING_USER_ACTION_TYPES.reject, index);
                                  }}
                                >
                                  מחק
                                </Button>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <div
                                className={`is-info-wrapper ${
                                  currentUser.pendingType === PENDING_USER_TYPES.bquickRegister ? "primary-color" : "yellow-color"
                                }`}
                              >
                                ----{" "}
                                {currentUser.pendingType === PENDING_USER_TYPES.bquickRegister ? (
                                  <Fragment>
                                    <img className="tiny-logo ml-10" alt="logo" src={bquickLogo} />
                                    Bquick Register
                                  </Fragment>
                                ) : (
                                  <Fragment>
                                    <img className="tiny-logo ml-10" alt="logo" src={btaxLogo} />
                                    Btax Register
                                  </Fragment>
                                )}
                                ----
                              </div>
                              <Button
                                disabled={this.state.isExistingSelected[index]}
                                className="mr-20"
                                color="primary"
                                variant="contained"
                                onClick={() => {
                                  this.triggerActionSelected(PENDING_USER_ACTION_TYPES.reject, index);
                                }}
                              >
                                דחה
                              </Button>
                              <div className="inline-block">
                                <Button
                                  disabled={this.state.isExistingSelected[index]}
                                  className="mr-20"
                                  color="primary"
                                  variant="contained"
                                  onClick={() => {
                                    this.triggerActionSelected(PENDING_USER_ACTION_TYPES.existing, index);
                                  }}
                                >
                                  שלב
                                </Button>
                              </div>
                              <div className="inline-block">
                                <Button
                                  disabled={this.state.isExistingSelected[index]}
                                  className="mr-20"
                                  color="primary"
                                  variant="contained"
                                  onClick={() => {
                                    this.triggerActionSelected(PENDING_USER_ACTION_TYPES.new, index);
                                  }}
                                >
                                  חדש
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>

                        {this.state.isExistingSelected[index] ? (
                          <div>
                            <hr />

                            <TextField
                              id="existingCardNum"
                              type="number"
                              label="מס' כרטיס קיים"
                              onChange={(e) => {
                                this.existingDataChange("existingCardNum", index, e.target.value);
                              }}
                            />
                            <div className="existing-data-checkboxes-container">
                              <p style={{ marginBottom: 0 }}>
                                <span className="fs-12 block">סמן את סוגי המידע שיש לקחת מהמשתמש הממתין לאישור:</span>
                                <span className="fs-10 block"> (מה שאינו מסומן ילקח מהמידע שבכרטיס הקיים במערכת)</span>
                              </p>
                              <FormControlLabel
                                control={<Checkbox color="primary" />}
                                label="מייל"
                                onChange={(e) => {
                                  this.existingDataChange("email", index, e.target.checked);
                                }}
                                checked={this.state.existingData[index].email}
                              />
                              <FormControlLabel
                                control={<Checkbox color="primary" />}
                                label="משרד"
                                onChange={(e) => {
                                  this.existingDataChange("officeName", index, e.target.checked);
                                }}
                                checked={this.state.existingData[index].officeName}
                              />
                              <FormControlLabel
                                control={<Checkbox color="primary" />}
                                label="איש קשר"
                                onChange={(e) => {
                                  this.existingDataChange("contact", index, e.target.checked);
                                }}
                                checked={this.state.existingData[index].contact}
                              />
                              <FormControlLabel
                                control={<Checkbox color="primary" />}
                                label="מספר"
                                onChange={(e) => {
                                  this.existingDataChange("num", index, e.target.checked);
                                }}
                                checked={this.state.existingData[index].num}
                              />
                            </div>
                            <div className="inline-block">
                              <Button
                                className="mr-20"
                                color="primary"
                                variant="contained"
                                onClick={() => {
                                  this.triggerActionSelected(PENDING_USER_ACTION_TYPES.attachExistingCard, index);
                                }}
                              >
                                סיום
                              </Button>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  getCurrentPendingTable = function (currentUser) {
    if (currentUser.pendingType === PENDING_USER_TYPES.bquickRegister) {
      return (
        <table cellPadding="10">
          <tbody>
            <tr>
              <td>
                <b>אימייל</b>
              </td>
              <td>{currentUser.email}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>שם משרד</b>
              </td>
              <td>{currentUser.officeName}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>איש קשר</b>
              </td>
              <td>{currentUser.firstName}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>מספר</b>
              </td>
              <td>{currentUser.mobile}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>האם אישר אימייל</b>
              </td>
              <td>{currentUser.isEmailConfirmed === true ? "כן" : "לא"}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>תאריך בקשה</b>
              </td>
              <td>{moment(currentUser.dateCreated).format("DD-MM-YYYY")}</td>
            </tr>
          </tbody>
        </table>
      );
    } else if (currentUser.pendingType === PENDING_USER_TYPES.btaxRegister) {
      const curPendingMemberProf = adminService.getClientJobOptions().find((x) => x.key === currentUser.clientJobTitle);
      return (
        <table cellPadding="10">
          <tbody>
            <tr>
              <td>
                <b>אימייל</b>
              </td>
              <td>{currentUser.email}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>שם משרד</b>
              </td>
              <td>{currentUser.officeName}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>שם פרטי</b>
              </td>
              <td>{currentUser.firstName}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>שם משפחה</b>
              </td>
              <td>{currentUser.lastName}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>מספר נייד</b>
              </td>
              <td>{currentUser.mobile}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>מספר טלפון משרדי</b>
              </td>
              <td>{currentUser.officePhone}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>מקצוע</b>
              </td>
              <td>{curPendingMemberProf ? curPendingMemberProf.label : ""}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>כתובת משרד</b>
              </td>
              <td>{currentUser.officeAddress}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>שם משרד</b>
              </td>
              <td>{currentUser.officeName}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>מספר רשיון</b>
              </td>
              <td>{currentUser.licenseNumber}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>תאריך בקשה</b>
              </td>
              <td>{moment(currentUser.dateCreated).format("DD-MM-YYYY")}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>האם אישר אימייל</b>
              </td>
              <td>{currentUser.isEmailConfirmed === true ? "כן" : "לא"}</td>
            </tr>
          </tbody>
        </table>
      );
    } else {
      // expire
      return (
        <table cellPadding="10">
          <tbody>
            <tr>
              <td>
                <b>אימייל</b>
              </td>
              <td>{currentUser.email}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>שם משרד</b>
              </td>
              <td>{currentUser.officeName}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>איש קשר</b>
              </td>
              <td>{currentUser.firstName}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <b>תאריך יצירה</b>
              </td>
              <td>{moment(currentUser.dateCreated).format("DD-MM-YYYY")}</td>
            </tr>
          </tbody>
        </table>
      );
    }
  };

  redirectToSpecificUser = (_id, e) => {
    if (e.ctrlKey || e.metaKey || e.button === 1) window.open("/admin/specific-user/" + _id, "_blank");
    else this.props.history.push("/admin/specific-user/" + _id);
  };

  triggerActionSelected = (action, index) => {
    const isExistingSelected = [...this.state.isExistingSelected];
    if (action === PENDING_USER_ACTION_TYPES.reject) {
      Swal.fire({ title: "דחיית בקשה", text: "האם אתה בטוח?", showCancelButton: true }).then((res) => {
        if (res.value) {
          adminService.handlePendingUser(this.state.pendingUsers[index], action).then((res) => {
            if (res["success"]) {
              this.removePendingUserFromList(index, isExistingSelected);
            }
          });
        }
      });
    } else if (action === PENDING_USER_ACTION_TYPES.back) {
      isExistingSelected[index] = false;
      this.setState({ isExistingSelected });
    } else if (action === PENDING_USER_ACTION_TYPES.new) {
      Swal.fire({ title: "יצירת כרטיס חדש", text: "להמשיך?", showCancelButton: true }).then((res) => {
        if (res.value) {
          adminService.handlePendingUser(this.state.pendingUsers[index], action).then((res) => {
            if (res["success"]) {
              this.removePendingUserFromList(index, isExistingSelected);
            }
          });
        }
      });
    } else if (action === PENDING_USER_ACTION_TYPES.existing) {
      isExistingSelected[index] = true;
      this.setState({ isExistingSelected });
    } else if (action === PENDING_USER_ACTION_TYPES.attachExistingCard) {
      if (!this.state.existingData[index].existingCardNum) return;
      Swal.fire({ title: "שילוב כרטיס קיים", text: "להמשיך?", showCancelButton: true }).then((res) => {
        if (res.value) {
          adminService.handlePendingUser(this.state.pendingUsers[index], action, this.state.existingData[index]).then((res) => {
            if (res["success"]) {
              this.removePendingUserFromList(index, isExistingSelected);
            } else if (res.cardDoesntExist) {
              Swal.fire({ title: "שילוב לכרטיס קיים נכשל", text: "על המספר המבוקש לא קיים כרטיס", icon: "warning" });
            }
          });
        }
      });
    }
  };

  removePendingUserFromList = (index, isExistingSelected) => {
    let existingData = [...this.state.existingData];
    existingData.splice(index, 1);
    let pendingUsers = [...this.state.pendingUsers];
    pendingUsers.splice(index, 1);
    isExistingSelected.splice(index, 1);
    this.setState({ existingData, pendingUsers, isExistingSelected });
  };

  existingDataChange = (key, index, val) => {
    const existingData = [...this.state.existingData];
    if (key === "existingCardNum") {
      existingData[index]["existingCardNum"] = val;
    } else {
      if (val) existingData[index][key] = true;
      else existingData[index][key] = false;
    }

    this.setState({ existingData });
  };
}

export default AdminPendingUsersManager;
